import { createContext, useContext } from 'react';

export interface URLsContextType {
  TOSUrl: string | null | undefined;
}
export const URLsContext = createContext<URLsContextType | null>(null);

const useURLsContext = () => {
  const urlContext = useContext(URLsContext);

  if (!URLsContext) {
    throw new Error('useURLsContext has to be used within <URLsContext.Provider>');
  }

  return urlContext;
};

export default useURLsContext;